import * as react from "react";
import { PasswordModel__get_CanSubmit, PasswordMsg, OtpModel__get_CanSubmit, Msg, OtpMsg } from "./Types.fs.js";
import { DOMAttr, HTMLAttr } from "../../fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { keyValueList } from "../../fable_modules/fable-library-js.4.19.0/MapUtil.js";
import { empty, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.4.19.0/Seq.js";
import { errorMsg, spinner, validatedPasswordBoxWithoutErrorMsg, validatedTextBoxWithoutErrorMsg2 } from "../../../Bfs.Web.Portale/ViewParts.fs.js";
import { value } from "../../fable_modules/fable-library-js.4.19.0/Option.js";
import { int32ToString } from "../../fable_modules/fable-library-js.4.19.0/Util.js";

export function optBoxEnabeld(state, dispatch) {
    let children_6, children_4, children_2, children_10, children_8, children_14, props_14;
    const buttonStyle = state ? "is-danger" : "is-light";
    const children_16 = [(children_6 = [(children_4 = ["Ihr Account ist durch Zwei-Faktor-Authentifizierung abgesichert! ", (children_2 = [react.createElement("i", {
        className: "fas fa-check",
    })], react.createElement("span", {}, ...children_2))], react.createElement("b", {}, ...children_4))], react.createElement("p", {}, ...children_6)), (children_10 = [(children_8 = [react.createElement("input", {
        type: "checkbox",
        checked: state,
        onChange: (ev) => {
            dispatch(new Msg(2, [new OtpMsg(0, [ev.target.checked])]));
        },
    }), " Ich möchte die Zwei-Faktor-Authentifizierung deaktivieren."], react.createElement("label", {
        className: "checkbox",
    }, ...children_8))], react.createElement("p", {}, ...children_10)), (children_14 = [(props_14 = [new HTMLAttr(65, ["bfsbutton"]), new HTMLAttr(79, [!state]), new DOMAttr(40, [(_arg) => {
        if (state) {
            dispatch(new Msg(2, [new OtpMsg(6, [])]));
        }
    }])], react.createElement("button", keyValueList(props_14, 1), "Deaktivieren"))], react.createElement("p", {
        className: "is-pulled-right",
    }, ...children_14))];
    return react.createElement("div", {
        className: "paragraphs",
    }, ...children_16);
}

export function optBoxDisabeld(dispatch) {
    let children_2, children_4, s_1, children_6, children_10;
    const children_12 = [(children_2 = [react.createElement("b", {}, "Sie können ihren Account durch die Verwendung von Zwei-Faktor-Authentifizierung absichern:")], react.createElement("p", {}, ...children_2)), (children_4 = [(s_1 = "Sie benötigen eine Authenticator-App auf Ihrem Smartphone (z.B. Google Authenticator, Authy, 1Password, etc.), um für jede Anmeldung ein neues Einmalpasswort zu erzeugen.", s_1)], react.createElement("p", {}, ...children_4)), (children_6 = [react.createElement("img", {
        src: "BFS_2fa_prozess2x.jpg",
    })], react.createElement("p", {}, ...children_6)), (children_10 = [react.createElement("a", {
        className: "bfsbutton ",
        onClick: (_arg) => {
            dispatch(new Msg(2, [new OtpMsg(2, [])]));
        },
    }, "Jetzt aktivieren!")], react.createElement("p", {
        className: "is-pulled-right",
    }, ...children_10))];
    return react.createElement("div", {
        className: "paragraphs",
    }, ...children_12);
}

export function submitOtpOnEnter(dispatch) {
    return new DOMAttr(15, [(e) => {
        if (e.key === "Enter") {
            dispatch(new Msg(2, [new OtpMsg(4, [])]));
        }
    }]);
}

export function optBoxActivating(model, dispatch) {
    const children_14 = toList(delay(() => {
        let children, s;
        return append(singleton((children = [(s = "Bitte scannen Sie den QR-Code mit Ihrer Authenticator-App und verifizieren Sie Ihre App durch die Eingabe des in der App angezeigten Einmalpassworts.", s)], react.createElement("p", {
            className: "is-hidden-touch",
        }, ...children))), delay(() => {
            let children_2;
            return append(singleton((children_2 = [react.createElement("img", {
                src: model.QrCode,
            })], react.createElement("p", {
                className: "is-hidden-touch",
            }, ...children_2))), delay(() => {
                let children_4, s_1;
                return append(singleton((children_4 = [(s_1 = "Bitte geben Sie den folgenden Code in Ihrer Authenticator-App ein und verifizieren Sie Ihre App durch die Eingabe des in der App angezeigten Einmalpassworts.", s_1)], react.createElement("p", {
                    className: "is-hidden-desktop",
                }, ...children_4))), delay(() => append(singleton(react.createElement("p", {
                    className: "is-hidden-desktop is-size-3 has-text-justified otp-code",
                }, model.Secret)), delay(() => append(singleton(validatedTextBoxWithoutErrorMsg2([new HTMLAttr(54, ["off"]), submitOtpOnEnter(dispatch)])((arg_6) => {
                    dispatch(new Msg(2, [new OtpMsg(1, [arg_6])]));
                })("Einmalpasswort")("Otp")("123456")(model.OtpField)), delay(() => {
                    let children_8;
                    return append((model.ErrorMsg != null) ? singleton((children_8 = [value(model.ErrorMsg)], react.createElement("div", {
                        className: "is-pulled-left error-msg",
                    }, ...children_8))) : empty(), delay(() => {
                        let children_12, props_12;
                        return singleton((children_12 = [(props_12 = [new HTMLAttr(159, ["submit"]), new HTMLAttr(65, ["bfsbutton"]), new HTMLAttr(79, [!OtpModel__get_CanSubmit(model)]), new DOMAttr(40, [(_arg) => {
                            dispatch(new Msg(2, [new OtpMsg(4, [])]));
                        }])], react.createElement("button", keyValueList(props_12, 1), "Bestätigen"))], react.createElement("p", {
                            className: "is-pulled-right",
                        }, ...children_12)));
                    }));
                }))))));
            }));
        }));
    }));
    return react.createElement("div", {
        className: "paragraphs otp-form",
    }, ...children_14);
}

export function otpBox(model, dispatch) {
    let children_8, children_4, children_2, children_6;
    const children_10 = [(children_8 = [(children_4 = [(children_2 = [react.createElement("b", {}, "Account absichern")], react.createElement("h3", {}, ...children_2))], react.createElement("div", {
        className: "card-title",
    }, ...children_4)), (children_6 = toList(delay(() => {
        let matchValue;
        return singleton((matchValue = model.Status, (matchValue.tag === 1) ? optBoxActivating(model, dispatch) : ((matchValue.tag === 2) ? optBoxEnabeld(matchValue.fields[0], dispatch) : optBoxDisabeld(dispatch))));
    })), react.createElement("div", {
        className: "card-body",
    }, ...children_6))], react.createElement("div", {
        className: "flat-card profile-info-card is-auto",
    }, ...children_8))];
    return react.createElement("div", {
        className: "column is-6",
    }, ...children_10);
}

export function submitPasswordOnEnter(dispatch) {
    return new DOMAttr(15, [(e) => {
        if (e.key === "Enter") {
            dispatch(new Msg(3, [new PasswordMsg(3, [])]));
        }
    }]);
}

export function passwordChangeForm(model, dispatch) {
    return toList(delay(() => {
        let children;
        return append(singleton((children = [validatedPasswordBoxWithoutErrorMsg("is-tooltip-right", [submitPasswordOnEnter(dispatch)])((arg_6) => {
            dispatch(new Msg(3, [new PasswordMsg(0, [arg_6])]));
        })("Aktuelles Passwort")("OldPassword")("")(model.OldPassword)], react.createElement("div", {
            className: "info-block",
        }, ...children))), delay(() => {
            let children_2;
            return append(singleton((children_2 = [validatedPasswordBoxWithoutErrorMsg("is-tooltip-right", [submitPasswordOnEnter(dispatch)])((arg_13) => {
                dispatch(new Msg(3, [new PasswordMsg(1, [arg_13])]));
            })("Neues Passwort")("NewPassword1")("")(model.NewPassword1)], react.createElement("div", {
                className: "info-block",
            }, ...children_2))), delay(() => {
                let children_4;
                return append(singleton((children_4 = [validatedPasswordBoxWithoutErrorMsg("is-tooltip-right", [submitPasswordOnEnter(dispatch)])((arg_20) => {
                    dispatch(new Msg(3, [new PasswordMsg(2, [arg_20])]));
                })("Neues Passwort (Wiederholung)")("NewPassword2")("")(model.NewPassword2)], react.createElement("div", {
                    className: "info-block",
                }, ...children_4))), delay(() => {
                    let children_6;
                    return append((model.ErrorMsg != null) ? singleton((children_6 = [value(model.ErrorMsg)], react.createElement("div", {
                        className: "is-pulled-left error-msg",
                    }, ...children_6))) : empty(), delay(() => {
                        let children_10, props_8;
                        return singleton((children_10 = [(props_8 = [new HTMLAttr(159, ["submit"]), new HTMLAttr(65, ["bfsbutton"]), new HTMLAttr(79, [!PasswordModel__get_CanSubmit(model)]), new DOMAttr(40, [(_arg) => {
                            dispatch(new Msg(3, [new PasswordMsg(3, [])]));
                        }])], react.createElement("button", keyValueList(props_8, 1), "Ändern"))], react.createElement("p", {
                            className: "is-pulled-right",
                        }, ...children_10)));
                    }));
                }));
            }));
        }));
    }));
}

export function passwordBox(model, dispatch) {
    let children_8, children_4, children_2, children_6;
    const children_10 = [(children_8 = [(children_4 = [(children_2 = [react.createElement("b", {}, "Passwort ändern")], react.createElement("h3", {}, ...children_2))], react.createElement("div", {
        className: "card-title",
    }, ...children_4)), (children_6 = toList(delay(() => {
        const matchValue = model.OkMsg;
        return (matchValue != null) ? singleton(matchValue) : passwordChangeForm(model, dispatch);
    })), react.createElement("div", {
        className: "card-body paragraphs",
    }, ...children_6))], react.createElement("div", {
        className: "flat-card profile-info-card is-auto with-overflowing-tooltips",
    }, ...children_8))];
    return react.createElement("div", {
        className: "column is-6",
    }, ...children_10);
}

export function helloBox(model) {
    let children_12, children_10;
    const children_14 = [(children_12 = [(children_10 = toList(delay(() => {
        let matchValue, b, children_8, children_6;
        return singleton((matchValue = model.UserInfo, (matchValue.tag === 1) ? spinner : ((matchValue.tag === 2) ? errorMsg("Fehler beim Laden!") : ((matchValue.tag === 3) ? ((b = matchValue.fields[0], (children_8 = [(children_6 = toList(delay(() => append(singleton(react.createElement("h1", {
            className: "title",
        }, model.Name)), delay(() => {
            let children_4, copyOfStruct;
            return (b.Kundennummer != null) ? singleton((children_4 = ["Kundennummer: " + ((copyOfStruct = value(b.Kundennummer), int32ToString(copyOfStruct)))], react.createElement("p", {
                className: "subtitle",
            }, ...children_4))) : empty();
        })))), react.createElement("div", {
            className: "hero-body",
        }, ...children_6))], react.createElement("section", {
            className: "hero",
        }, ...children_8)))) : react.createElement("div", {})))));
    })), react.createElement("div", {
        className: "",
    }, ...children_10))], react.createElement("div", {
        className: "flat-card is-auto",
    }, ...children_12))];
    return react.createElement("div", {
        className: "column is-12",
    }, ...children_14);
}

export function view(model, dispatch, navigateTo) {
    const children = toList(delay(() => append(singleton(helloBox(model)), delay(() => append((model.Password != null) ? singleton(passwordBox(value(model.Password), dispatch)) : empty(), delay(() => ((model.Otp != null) ? singleton(otpBox(value(model.Otp), dispatch)) : empty())))))));
    return react.createElement("div", {
        className: "columns is-account-grid is-multiline",
    }, ...children);
}

//# sourceMappingURL=View.fs.js.map
